const USER_KEY = "USER_KEY";

export function setCookie(info) {
  localStorage.setItem(USER_KEY, JSON.stringify(info))
  return true;
}

export function getCookie() {
  let item = localStorage.getItem(USER_KEY);
  if (!item) {
    return {};
  }
  return JSON.parse(item);
}

export function removeCookie() {
  localStorage.removeItem(USER_KEY);
  return true;
}
